
import { Vue, Options } from "vue-class-component";
import { Pagination } from "@/domain/entities/Pagination";
import { CLIENT_ERROR, INTERNET_ERROR, INTERNAL_SERVER_ERROR, formatDate } from "@/app/infrastructures/misc/Utils";
import { SttHangingController } from "@/app/ui/controllers/SttHangingController";
import {
  RiwayatHangingLasmileRequest,
  ListRiwayatHangingLasmile,
  HistoryHangingIncomingFilterRequest
} from "@/domain/entities/HangingIncoming";
import FilterHistory from "../components/filter-history.vue";
import { debounce } from "lodash";
import PaginationV3 from "@/app/ui/components/pagination-v3/index.vue";

@Options({
  components: {
    FilterHistory,
    PaginationV3
  }
})
class TabRiwayatHangingLastmile extends Vue {
  isLoading = false;
  errorState = "";
  pagination = new Pagination(1, 10);
  params = new RiwayatHangingLasmileRequest();
  dataListRiwayatHangingLasmile: ListRiwayatHangingLasmile[] = [];
  async mounted() {
    await this.fetchRiwayatHangingList();
  }

  filterHistoryHangingLastMile = debounce(
    (params: HistoryHangingIncomingFilterRequest) => {
      if (this.isLoading) return;
      this.params = new RiwayatHangingLasmileRequest(params);
      this.fetchRiwayatHangingList();
    },
    250
  );

  async fetchRiwayatHangingList() {
    try {
      this.isLoading = true;
      this.errorState = "";
      const res = await SttHangingController.getRiwayatHangingLastmile(this.params);
      console.log(res);
      this.dataListRiwayatHangingLasmile = res.data;
      this.pagination = res.pagination;
    } catch (error) {
      this._handlerError(error);
    } finally {
      this.isLoading = false;
    }
  }

  _handlerError(error: any) {
    if (!error.response) {
      this.errorState = INTERNET_ERROR;
      return;
    }
    if (error.response.status > 500) {
      this.errorState = CLIENT_ERROR;
      return;
    }
    this.errorState = INTERNAL_SERVER_ERROR;
  }

  toPageV3(value: number) {
    if (value === this.pagination.page) {
      return;
    }
    this.pagination.page = value;
    this.params.page = value;
    this.fetchRiwayatHangingList();
  }


  mapHangingDays(item: ListRiwayatHangingLasmile) {
    const colorMap: Record<number, string> = {
      1: "bg-aqua-lp-200 text-aqua-lp-500",
      2: "bg-aqua-lp-200 text-aqua-lp-500",
      3: "bg-aqua-lp-200 text-aqua-lp-500",
      4: "bg-aqua-lp-200 text-aqua-lp-500",
      5: "bg-yellow-lp-200 text-yellow-lp-100",
      6: "bg-orange-lp-100 text-orange-lp-200"
    };

    let color = "bg-white text-gray-lp-300";

    if (item.hangingDays != null) {
      if (colorMap[item.hangingDays]) {
        color = colorMap[item.hangingDays];
      } else if (item.hangingDays >= 7) {
        color = "bg-red-lp-2000 text-white";
      }
    }

    const label =
      item.hangingDays != null
        ? item.hangingDays < 7
          ? `${item.hangingDays} ${this.$t('dashboard.hanging.dayUnit')}`
          : this.$t('dashboard.hanging.day7Plus')
        : "-";

    return { label, color };
  }

  mapTicketStatus(stt: ListRiwayatHangingLasmile) {
    const label: any = {
      "belum_ditemukan": this.$t('dashboard.hanging.statusNotFound'),
      "ditemukan_konsol": this.$t('dashboard.hanging.statusFoundConsole'),
      "ditemukan_pos": this.$t('dashboard.hanging.statusFoundPos')
    }

    const color: any = {
      "belum_ditemukan": "bg-pink-lp-200 text-red-lp-100",
      "ditemukan_konsol": "bg-blue-lp-600 text-blue-lp-700",
      "ditemukan_pos": "bg-purple-lp-100 text-purple-lp-800"
    }

    return {
      label: label[stt.existenceStatus] ?? "-",
      color: color[stt.existenceStatus] ?? ""
    }
  }

  // Format Date
  formatDateToString(date: string) {
    return formatDate(date);
  }

  extractDateTime(input: string) {
    if (!input) return "";

    const dateMatch = input.match(/\b(\d{4})[-/](\d{2})[-/](\d{2})\b/);

    const timeMatch = input.match(/\b(\d{2}):(\d{2})(?::(\d{2}))?\b/);

    const date = dateMatch ? `${dateMatch[1]}-${dateMatch[2]}-${dateMatch[3]}` : null;
    const time = timeMatch ? `${timeMatch[1]}:${timeMatch[2]}` : null;

    return `${date}, ${time}`;
  }
}
export default TabRiwayatHangingLastmile;
